import Ambient from './components/landing/Ambient';
import FinalSection from './components/landing/FinalSection';
import Footer from './components/landing/Footer';
import Header from './components/landing/Header';
import Hero from './components/landing/Hero';
import LaunchSection from './components/landing/LaunchSection';
import LifestyleSection from './components/landing/LifestyleSection';
import RedPacketsSection from './components/landing/RedPacketsSection';
import RewardsSection from './components/landing/RewardsSection';
import RoadmapSection from './components/landing/RoadmapSection';
import StatsSection from './components/landing/StatsSection';
import TrustSection from './components/landing/TrustSection';
import WhatSection from './components/landing/WhatSection';
import useLandingEffects from './hooks/useLandingEffects';

function App() {
    useLandingEffects();

    return (
        <>
            <a className="skip" href="#main">
                Skip to content
            </a>
            <Ambient />
            <Header />
            <main id="main">
                <Hero />
                <WhatSection />
                <LaunchSection />
                <StatsSection />
                <LifestyleSection />
                <RedPacketsSection />
                <RewardsSection />
                <TrustSection />
                <RoadmapSection />
                <FinalSection />
            </main>
            <Footer />
        </>
    );
}

export default App;
